import { NotificationManager } from "react-notifications";
import { Actions as COMPANY_ACTIONS } from "../../../../store/actions/companyActions";
import { Actions as INTEGRATION_ACTIONS } from "../../../../store/actions/integrationActions";

import apiURL from "../../../../store/actions/apiURL";
import { createRequest } from "@/components/common/helpers/RequestHelpers";
import {format} from "date-fns";

const tandaRequest = createRequest({
	urlPath: "/integrations/tanda",
	local: false,
});

const Types = {
	WORKFORCE_IMPORT_TIMESHEETS: "WORKFORCE_IMPORT_TIMESHEETS",
	WORKFORCE_IMPORT_LEAVE: "WORKFORCE_IMPORT_LEAVE",
	WORKFORCE_EMPLOYEE_LINKS: "WORKFORCE_EMPLOYEE_LINKS",
	WORKFORCE_TEAMS: "WORKFORCE_TEAMS",
	WORKFORCE_SET_TEAMS: "WORKFORCE_SET_TEAMS",
	WORKFORCE_AUTO_MAP_RESULT: "WORKFORCE_AUTO_MAP_RESULT",
	WORKFORCE_AUTO_MAP_LOADING: "WORKFORCE_AUTO_MAP_LOADING",
};

const setImportingTimesheets = (status) => ({
	type: Types.WORKFORCE_IMPORT_TIMESHEETS,
	status,
});
const setImportingLeave = (status) => ({
	type: Types.WORKFORCE_IMPORT_LEAVE,
	status,
});
const updateEmployeeLinks = (links, employees) => ({
	type: Types.WORKFORCE_EMPLOYEE_LINKS,
	links,
	employees,
});
const updateTeams = (teams, locations) => ({
	type: Types.WORKFORCE_TEAMS,
	teams,
	locations,
});

const updateAgreementTeams = ({ teams, agreement }) => ({
	type: Types.WORKFORCE_SET_TEAMS,
	teams,
	agreement,
});

const loadAutoMapResult = (result) => ({
	type: Types.WORKFORCE_AUTO_MAP_RESULT,
	result,
});

const loadingAutoMap = (status) => ({
	type: Types.WORKFORCE_AUTO_MAP_LOADING,
	status,
});

const connectWorkforce = () => {
	return (dispatch, getState) => {

		const state = getState()
		// window.localStorage.setItem('lastUrl',window.location.href)

		// const url = window.location.href;
		const url = state.integration?.timeAttendance?.tanda?.connectUrl


		fetch(url, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				window.location.href = data.url;
				dispatch(COMPANY_ACTIONS.getCompanySettings());
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Connecting Workforce", "Connect Workforce");
			});
	};
};

const disconnectWorkforce = () => {
	return (dispatch, getState) => {
		tandaRequest({
			method: "DELETE",
			path: "/"
		})
			.then(() => {
				dispatch(COMPANY_ACTIONS.getCompanySettings());
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Disconnecting Workforce", "Disconnect Workforce");
			});
	};
};

const setImportStatus = (type, status) => {
	return (dispatch) => {
		switch (type) {
			case "Timesheets":
				dispatch(setImportingTimesheets(status));
				break;
			case "Leave":
				dispatch(setImportingLeave(status));
				break;
			default:
				break; // to avoid eslint error
		}
	};
};

const checkImportStatus = (arn, type) => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/describe-execution/${arn}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				const finished = data.data.status !== "RUNNING";

				if (finished) {
					if (data.data.status === "SUCCEEDED") {
						NotificationManager.success(
							`Successfully Imported ${type} from Workforce!`,
							"Importing From Workforce",
						);
						dispatch(setImportStatus(type, false));
					} else {
						NotificationManager.error(`Error Importing ${type} from Workforce`, "Importing From Workforce");
						dispatch(setImportStatus(type, false));
					}
				} else {
					setTimeout(() => dispatch(checkImportStatus(arn, type)), 1000);
				}
			});
	};
};

const importWorkforceEntries = ({from, to, type, agreementId, department, updateIfNotLast24Hours}) => {
	return (dispatch, getState) => {
		dispatch(setImportStatus(type, true));
		NotificationManager.info(`Importing ${type} from Workforce`, "Importing From Workforce");

		tandaRequest({
			method: "GET",
			path: `/import/${type?.toLowerCase()}`,
			query: {
				from: format(new Date(from),"yyyy-MM-dd"),
				to: format(new Date(to),"yyyy-MM-dd"),
				agreementId,
				department,
				updateIfNotLast24Hours,
			}
		})
			.then(({data}) => {
				console.log('data',data)
				dispatch(checkImportStatus(data.arn, type));
			})
			.catch((error) => {
				NotificationManager.error(`Error Importing ${type} from Workforce`, "Importing From Workforce");
				console.error(error);
				dispatch(setImportStatus(type, false));
			});
	};
};

const linkEmployee = ({ agreement, referenceLink }) => {
	return (dispatch, getState) => {
		tandaRequest({
			method: "POST",
			path: "/employee",
			body: {
				agreement,
				referenceLink,
			},
		})
			.then((response) => {
				dispatch(getWorkforceEmployees());
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Linking Employee with Workforce", "Linking Employee with Workforce");
			});
	};
};

const linkEmployees = (links) => {
	return (dispatch, getState) => {
		tandaRequest({
			method: "POST",
			path: "/employees",
			body: links,
		})
			.then(({ data }) => {
				NotificationManager.success(
					`Successfully Linked ${links?.length} Employees!`,
					"Linking Employees with Workforce",
				);
				dispatch(getWorkforceEmployees());
				dispatch(INTEGRATION_ACTIONS.toggleBulkLinkModal());
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Linking Employees with Workforce", "Linking Employees with Workforce");
			});
	};
};

const setEmployeeTeams = ({ agreement, teams, id }) => {
	return (dispatch, getState) => {
		tandaRequest({
			method: "POST",
			path: "/teams",
			body: {
				agreement,
				teams,
				id
			},
		})
			.then((response) => {
				dispatch(updateAgreementTeams({ agreement, teams }));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error(
					"Error Updating Employee teams with Workforce",
					"Linking Employee Teams with Workforce",
				);
			});
	};
};

const getWorkforceEmployees = () => {
	return (dispatch, getState) => {

		tandaRequest({
			method: "GET",
			path: "/employees"
		})
			.then(({ data }) => {
				const { links, employees } = data;
				dispatch(updateEmployeeLinks(links, employees));
			})
			.catch((error) => {
				console.error(error);
			});
	};
};
const getWorkforceTeams = () => {
	return (dispatch, getState) => {
		tandaRequest({
			method: "GET",
			path: "/teams"
		})
			.then(({ data }) => {
				const { teams, locations } = data;
				dispatch(updateTeams(teams, locations));
			})
			.catch((error) => {
				console.error(error);
			});
	};
};

const saveWorkforceSettings = (data) => {
	return (dispatch, getState) => {
		tandaRequest({
			path: "/",
			method: "POST",
			body: data,
		})
			.then((response) => {
                NotificationManager.success("Successfully Saved Workforce Settings", "Saving Workforce Settings");
            })
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Saving Workforce Settings", "Saving Workforce Settings");
			});
	};
};

const autoMapEmployees = () => {
	return async (dispatch, getState) => {
		dispatch(loadingAutoMap(true));
		await tandaRequest({
			method: "GET",
			path: "/auto-map",
		})
			.then(({ data }) => {
				console.log("Elapsed time: ", data.timeElapsed);
				if (data.found.length > 0) {
					NotificationManager.success(
						`AutoMap linked ${data.found.length} employees!`,
						"AutoMap Workforce Employees",
					);
					dispatch(getWorkforceEmployees());
				} else {
					NotificationManager.warning("No Employees could be linked", "AutoMap Workforce Employees");
				}
				dispatch(loadAutoMapResult(data.notFound?.map(({ id }) => id)));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Linking Employees with Workforce", "Linking Employees with Workforce");
			});
		dispatch(loadingAutoMap(false));
	};
};

const Actions = {
	connectWorkforce,
	autoMapEmployees,
	disconnectWorkforce,
	linkEmployee,
	linkEmployees,
	setEmployeeTeams,
	getWorkforceTeams,
	getWorkforceEmployees,
	saveWorkforceSettings,
	importWorkforceEntries,
};

export { Types, Actions };
